/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Advanced_Maintenance_Location_Subtitle_ValvesInputs */



/**
* | output |
* | --- |
* | "Click on the room or floor to open it" |
*
* @param {Advanced_Maintenance_Location_Subtitle_ValvesInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const advanced_maintenance_location_subtitle_valves = /** @type {((inputs?: Advanced_Maintenance_Location_Subtitle_ValvesInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Advanced_Maintenance_Location_Subtitle_ValvesInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Click on the room or floor to open it")
	return /** @type {LocalizedString} */ ("Cliquer sur la pièce ou le niveau pour y accéder")
});